import React from 'react';

interface AppInstallContextProps {
  install?: () => void;
}

const AppInstallContext = React.createContext<AppInstallContextProps | null>(null);

export default AppInstallContext;
